// Yoonly FR overrides - only keys that differ from regular FR translations.
// Missing keys automatically fall back to the standard "fr" locale.
const summeryYoonlyFrTranslations: any = {
    "bestPrice": {
        "description": "En réservant avec Yoonly, vous bénéficiez de la garantie du meilleur prix."
    }
};

export default summeryYoonlyFrTranslations;
